var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.getIsAdminRights === 'admin')?_c('UsersEditAdmin',{attrs:{"UEAdmin":_vm.UEAdmin,"orderFees":_vm.orderFees,"orderFBAFees":_vm.orderFBAFees,"shipStation":_vm.shipStation,"isAdminType":_vm.isAdminType},on:{"changeUser":_vm.changeUser,"reload":_vm.reload}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }